import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularSwap: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_swap"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="swap icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6832 2.22253C11.9745 2.51699 11.9719 2.99186 11.6775 3.28317L10.4245 4.52273H17.1C17.7851 4.52273 18.7972 4.71994 19.6601 5.33458C20.5617 5.97675 21.25 7.04305 21.25 8.63636C21.25 10.2297 20.5617 11.296 19.6601 11.9381C18.7972 12.5528 17.7851 12.75 17.1 12.75H6.9C6.45173 12.75 5.76389 12.8892 5.21012 13.2836C4.69501 13.6505 4.25 14.266 4.25 15.3636C4.25 16.4612 4.69501 17.0768 5.21012 17.4437C5.76389 17.8381 6.45173 17.9773 6.9 17.9773H15.2755L14.0225 16.7377C13.7281 16.4464 13.7255 15.9715 14.0168 15.6771C14.3081 15.3826 14.783 15.3801 15.0775 15.6714L17.6275 18.1941C17.7699 18.335 17.85 18.527 17.85 18.7273C17.85 18.9276 17.7699 19.1196 17.6275 19.2604L15.0775 21.7832C14.783 22.0745 14.3081 22.0719 14.0168 21.7775C13.7255 21.483 13.7281 21.0081 14.0225 20.7168L15.2755 19.4773H6.9C6.21493 19.4773 5.20277 19.2801 4.33988 18.6654C3.43833 18.0232 2.75 16.9569 2.75 15.3636C2.75 13.7703 3.43833 12.704 4.33988 12.0619C5.20277 11.4472 6.21493 11.25 6.9 11.25H17.1C17.5483 11.25 18.2361 11.1108 18.7899 10.7164C19.305 10.3495 19.75 9.73396 19.75 8.63636C19.75 7.53877 19.305 6.92325 18.7899 6.55633C18.2361 6.16188 17.5483 6.02273 17.1 6.02273H10.4245L11.6775 7.26228C11.9719 7.5536 11.9745 8.02846 11.6832 8.32293C11.3919 8.61739 10.917 8.61994 10.6225 8.32863L8.07253 5.8059C7.93013 5.66502 7.85 5.47304 7.85 5.27273C7.85 5.07242 7.93013 4.88043 8.07253 4.73955L10.6225 2.21683C10.917 1.92551 11.3919 1.92807 11.6832 2.22253Z"
        />
      </svg>
    </span>
  );
};

export { RegularSwap };
